<button matIconButton aria-label="Send email" (click)="onClick()">
  <mat-icon>mail</mat-icon>
</button>
